<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 10:33:33
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-18 09:43:08
-->
<template>
  <div class="paper-design">
    <div class="question-wrapper">
      <div class="title">
        试题列表
        <el-dropdown placement="bottom-start" @command="handleAddQuestion">
          <span class="el-dropdown-link">
            <i class="el-icon-plus"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="typeDropdown">
            <el-dropdown-item v-for="item in typeOptions" :key="item.type" :command="item.type">{{
              item.name
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="question-list">
        <draggable
          v-model="questionList"
          class="drag"
          chosen-class="chosen"
          animation="300"
          :disabled="loading"
          filter=".forbid"
          :move="onMove"
          @end="onDragEnd"
        >
          <transition-group>
            <div
              v-for="(item, index) in questionList"
              :key="item.id"
              :class="[
                'question-item',
                { active: item.id == activeQustion.id },
                { forbid: !item.questionId },
              ]"
              @click="selectQuestion(item)"
            >
              <div class="index">{{ index + 1 }}</div>
              <div
                class="type"
                :style="
                  `color:${typeMap[item.questionType - 1].color};background-color:${
                    typeMap[item.questionType - 1].bgColor
                  }`
                "
              >
                {{ typeMap[item.questionType - 1].name }}
              </div>
              <div class="name">{{ replaceHtml(item.questionName || '') }}</div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
    <div class="design-wrapper">
      <div class="title">编辑试题</div>
      <div class="design">
        <el-empty v-if="!activeQustion.id" description="未选择试题"></el-empty>
        <template v-if="activeQustion.id">
          <div class="header">
            <div class="index">
              <span>【{{ typeMap[activeQustion.questionType - 1].name }}】</span>第{{
                activeQustion.questionSort
              }}题
            </div>
            <div class="score">
              本题分值<el-input-number
                v-model.number="questionInfo.score"
                :controls="false"
                :min="0"
              ></el-input-number
              >分
            </div>
          </div>
          <Single
            v-show="activeQustion.questionType == 1"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Multiple
            v-show="activeQustion.questionType == 2"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Judge
            v-show="activeQustion.questionType == 4"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Completion
            v-show="activeQustion.questionType == 5"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Subjective
            v-show="activeQustion.questionType == 3 || activeQustion.questionType > 5"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import Judge from './components/Judge'
import Single from './components/Single'
import Completion from './components/Completion'
import Multiple from './components/Multiple'
import Subjective from './components/Subjective'
import {
  paperQuestionList,
  paperQuestionSort,
  paperQuestionDetail,
  paperQuestionCreate,
  paperQuestionEdit,
  paperQuestionRemove,
  examPaperDetail,
} from '@/api/exam'
import to from 'await-to'
export default {
  name: 'PaperDesign',
  components: {
    draggable,
    Judge,
    Single,
    Completion,
    Multiple,
    Subjective,
  },
  data() {
    return {
      loading: false,
      activeQustion: {},
      score: 1,
      typeMap: [
        { name: '单选题', color: '#3671BF', bgColor: '#EBF2FA' },
        { name: '多选题', color: '#36BFA8', bgColor: '#EBFAF8' },
        { name: '计算题', color: '#B4872E', bgColor: '#FAF4E9' },
        { name: '判断题', color: '#2EBE46', bgColor: '#EBFAED' },
        { name: '填空题', color: '#9DB236', bgColor: '#F7FAE9' },
        { name: '简答题', color: '#BF4D36', bgColor: '#FAEBE9' },
        { name: '论述题', color: '#BF367B', bgColor: '#FAEEF3' },
        { name: '案例分析题', color: '#4D36BF', bgColor: '#EEEBFA' },
        { name: '综合题', color: '#A836BF', bgColor: '#F8EBFA' },
      ],
      questionList: [],
      questionInfo: {
        optionList: [],
      },
      saveLoading: false,
      paperType: '',
    }
  },
  computed: {
    // 理论试卷仅可添加单选、多选、判断题
    typeOptions() {
      return this.typeMap
        .map((item, index) => ({ ...item, type: index + 1 }))
        .filter(item => this.paperType != 2 || [1, 2, 4].includes(item.type))
    },
  },
  async mounted() {
    this.getPaperInfo()
    await this.getQuestionList()
    this.selectQuestion(this.questionList[0])
  },
  methods: {
    async getPaperInfo() {
      const [res, err] = await to(examPaperDetail({ id: this.$route.query.id }))
      if (err) return
      this.paperType = res.data.paperType
    },
    selectQuestion(item) {
      this.activeQustion = item
      this.getQuestionInfo(this.activeQustion.id)
    },
    async getQuestionList() {
      this.loading = true
      const [res, err] = await to(paperQuestionList({ paperId: this.$route.query.id }))
      if (err) return this.$message.warning(err.msg)
      this.loading = false
      this.questionList = res.data
      // this.activeQustion = res.data[0]
    },
    async handleAddQuestion(command) {
      const [res, err] = await to(
        paperQuestionCreate({
          paperId: this.$route.query.id,
          questionType: command,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      await this.getQuestionList()
      this.selectQuestion(
        this.questionList.filter(item => item.id == res.data.paperQuestionId)[0] || {},
      )
      // let newQuestion = {
      //   id: res.data.paperQuestionId,
      //   paperId: this.$route.query.id,
      //   questionId: '',
      //   questionName: '',
      //   questionSort: this.questionList.length,
      //   questionType: command,
      // }
      // this.questionList.push(newQuestion)
    },
    async sortQuestionList() {
      let indexList = this.questionList.map((item, index) => {
        if (typeof item.id == 'number') {
          return {
            id: item.id,
            index,
          }
        }
      })
      indexList = indexList.filter(item => item)
      const [, err] = await to(paperQuestionSort({ indexList }))
      if (err) return this.$message.warning(err.msg)
      let id = this.activeQustion.id
      await this.getQuestionList()
      this.activeQustion = this.questionList.filter(item => item.id == id)[0] || {}
    },
    onMove(e) {
      return !!e.relatedContext.element.questionId
    },
    onDragEnd() {
      this.sortQuestionList()
    },
    async getQuestionInfo(id) {
      const [res, err] = await to(paperQuestionDetail({ id }))
      if (err) return this.$message.warning(err.msg)
      this.questionInfo = res.data
      if (this.questionInfo.optionList.length) {
        for (let i = 0; i < this.questionInfo.optionList.length; i++) {
          const option = this.questionInfo.optionList[i]
          if (option.rightKey) {
            if (this.questionInfo.questionType == 2) {
              if (!this.questionInfo.rightOptionId)
                this.$set(this.questionInfo, 'rightOptionId', [])
              this.questionInfo.rightOptionId.push(option.id)
            } else {
              this.$set(this.questionInfo, 'rightOptionId', option.id)
            }
          }
        }
      } else {
        let optionList = []
        if (this.activeQustion.questionType == 4) {
          // 判断题
          optionList = [
            {
              id: 'new0',
              optionName: '对',
            },
            {
              id: 'new1',
              optionName: '错',
            },
          ]
        } else {
          optionList = [
            {
              id: 'new0',
              optionName: '',
            },
          ]
        }
        this.questionInfo = {
          score: 1,
          questionType: this.activeQustion.questionType,
          rightOptionId: this.activeQustion.questionType == 2 ? ['new0'] : 'new0',
          optionList,
        }
        console.log(optionList, 11)
      }
    },
    async editQuestionInfo(questionInfo) {
      this.saveLoading = true
      const [, err] = await to(paperQuestionEdit(questionInfo))
      setTimeout(() => {
        this.saveLoading = false
      }, 500)
      if (err) return this.$message.warning(err.msg)
      this.$message.success('编辑成功')
      this.getQuestionList()
    },
    deleteQuestion(question) {
      this.$confirm(`您确定要删除试题吗？删除后将无法恢复`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(paperQuestionRemove({ id: question.id }))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          await this.getQuestionList()
          this.activeQustion = {}
        })
        .catch(() => {})
    },
    onEdit(params) {
      this.editQuestionInfo({ ...params, id: this.activeQustion.id })
    },
    onRemove() {
      if (this.activeQustion.id.toString().indexOf('new') != -1) {
        this.questionList.map((item, index) => {
          if (item.id == this.activeQustion.id) {
            this.activeQustion = {}
            return this.questionList.splice(index, 1)
          }
        })
      } else {
        this.deleteQuestion(this.activeQustion)
      }
    },
    replaceHtml(str) {
      return str.replace(/<[^>]+>/g, '')
    },
  },
}
</script>
<style lang="scss" scoped>
.typeDropdown {
  width: 130px;
  .el-dropdown-menu__item {
    height: 36px;
    padding-left: 30px;
  }
}
.paper-design {
  height: 100vh;
  overflow: hidden;
  display: flex;
  .question-wrapper {
    height: 100%;
    background-color: #fff;
    width: 340px;
    margin-right: 20px;
    .title {
      height: 50px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 500;
      color: #434b51;
      line-height: 50px;
      border-bottom: 1px solid #eceef2;
      box-sizing: border-box;
      i {
        font-size: 16px;
        cursor: pointer;
        color: #3671bf;
      }
    }
    .question-list {
      box-sizing: border-box;
      padding: 10px;
      overflow: auto;
      height: calc(100% - 50px);
    }
    .question-item {
      box-sizing: border-box;
      padding: 10px;
      cursor: move;
      display: flex;
      align-items: center;
      border-radius: 4px;
      &.active {
        .index {
          background: #3671bf;
          color: #fff;
          border-color: #3671bf;
        }
        .name {
          color: #3671bf;
        }
      }
      .index {
        width: 36px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #e6e8ed;
        font-size: 16px;
        font-weight: 400;
        color: #606266;
        text-align: center;
        box-sizing: border-box;
        line-height: 22px;
        margin-right: 10px;
      }
      .type {
        padding: 5px 4px;
        white-space: nowrap;
        font-size: 14px;
        line-height: 14px;
      }
      .name {
        flex: 1;
        font-size: 16px;
        font-weight: 400;
        color: #4d4d4d;
        @extend %one-line-text;
        padding-left: 4px;
      }
    }
    .chosen {
      box-shadow: 0 6px 16px -8px #00000014, 0 9px 28px #0000000d, 0 12px 48px 16px #00000008;
    }
  }
  .design-wrapper {
    overflow: hidden;
    position: relative;
    flex: 1;
    background-color: #fff;
    padding-bottom: 20px;
    .title {
      height: 50px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 500;
      color: #434b51;
      line-height: 50px;
      border-bottom: 1px solid #eceef2;
      box-sizing: border-box;
    }
    .design {
      box-sizing: border-box;
      height: calc(100% - 90px);
      padding: 20px;
      overflow: auto;
      .header {
        box-sizing: border-box;
        width: 883px;
        height: 52px;
        background: #f5f7fa;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        padding: 0 20px 0 10px;
        span {
          color: #3671bf;
        }
        /deep/ .el-input-number {
          width: 60px;
          margin: 0 4px;
          .el-input {
            width: 60px;
            border-radius: 2px;
            input {
              box-sizing: border-box;
              height: 32px;
              padding: 0 4px;
            }
          }
        }
      }
      /deep/.footer {
        z-index: 99;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60px;
        background: #ffffff;
        box-shadow: 0px -2px 10px 1px #e7ebf2;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-button {
          width: 100px;
          height: 40px;
          border-radius: 4px;
          margin: 0 10px;
        }
      }
    }
  }
}
</style>
